export default __webpack_public_path__ + "static/media/tea.4a48272e.svg";